
import { Observable } from '../../Observable';
import { distinctUntilChanged } from '../../operator/distinctUntilChanged';

Observable.prototype.distinctUntilChanged = distinctUntilChanged;

declare module '../../Observable' {
  interface Observable<T> {
    distinctUntilChanged: typeof distinctUntilChanged;
  }
}


// WEBPACK FOOTER //
// ../../../src/add/operator/distinctUntilChanged.ts